<template>
    <el-dialog v-dialogDrag class="dialog" width="1100px"
               :visible.sync="dialogVisible" v-loading="dialoading"
               :close-on-click-modal="false"
               top="10vh" @close="close" center>
        <div slot="title">
            <div class="dialog_title">
                销售合同
            </div>
        </div>
        <div class="dialog_body">
            <el-container class="mxInfo">
                <el-main style="overflow-y: hidden;padding-bottom: 10px">
                    <div>
                        <el-form :inline="true" style="text-align: left;padding-left:10px;" label-width="120px">
                            <div>
                                <el-form-item label="项目名称">
                                    <el-input style="width:200px" v-model="form.projectName" placeholder="请输入项目名称"
                                              @click.native="selProject">
                                    </el-input>
                                </el-form-item>
                                <el-form-item label="甲方单位" required>
                                    <el-input style="width:200px" v-model="form.departmentName" placeholder="请选择甲方单位"
                                              @click.native="clickDept">
                                    </el-input>
                                </el-form-item>
                                <el-form-item label="业务员" required>
                                    <el-input style="width:200px" v-model="form.salesMan" placeholder="请选择或输入业务员"
                                              @click.native="clickStaff">
                                    </el-input>
                                </el-form-item>

                            </div>

                            <div>
                                <el-form-item label="乙方单位" required>
                                    <el-input style="width:200px" v-model="form.customerName" placeholder="请选择乙方单位"
                                              readonly
                                              @click.native="selCustomer">
                                    </el-input>
                                </el-form-item>
                                <el-form-item label="乙方签订人">
                                    <el-input style="width:200px" v-model="form.contactName" readonly
                                              placeholder="选择单位后自动赋值">
                                    </el-input>
                                </el-form-item>
                                <el-form-item label="乙方联系方式">
                                    <el-input style="width:200px" v-model="form.contactTel" readonly
                                              placeholder="选择单位后自动赋值">
                                    </el-input>
                                </el-form-item>
                            </div>

                            <div>
                                <el-form-item label="合同编号" required>
                                    <el-input style="width:200px" v-model="form.billNo" placeholder="请选择合同编号">
                                    </el-input>
                                </el-form-item>
                                <el-form-item label="合同名称" required>
                                    <el-input style="width:200px" v-model="form.contractName" placeholder="请选择合同名称">
                                    </el-input>
                                </el-form-item>
                                <el-form-item label="合同类型" required>
                                    <el-select v-model="form.contractType" placeholder="请选择合同类型" style="width: 200px">
                                        <el-option label="销售合同" value="销售合同"></el-option>
                                        <el-option label="其他合同" value="其他合同"></el-option>
                                    </el-select>
                                </el-form-item>
                            </div>

                            <div>
                                <el-form-item label="合同签订金额">
                                    <el-input style="width:200px" v-model="form.taxTotal" placeholder="根据明细自动计算"
                                              readonly>
                                    </el-input>
                                </el-form-item>
                                <el-form-item label="发票类型" required>
                                    <el-select v-model="form.invoiceType" placeholder="请选择发票类型" style="width: 200px">
                                        <el-option label="普通发票" value="普通发票"></el-option>
                                        <el-option label="增值税专用发票" value="增值税专用发票"></el-option>
                                        <el-option label="不开票" value="不开票"></el-option>
                                    </el-select>
                                </el-form-item>
                                <el-form-item label="计税方式" required>
                                    <el-select v-model="form.taxType" placeholder="请选择计税方式" style="width: 200px">
                                        <el-option label="一般计税" value="一般计税"></el-option>
                                        <el-option label="简易计税" value="简易计税"></el-option>
                                        <el-option label="不计税" value="不计税"></el-option>
                                    </el-select>
                                </el-form-item>
                            </div>

                            <div>
                                <el-form-item label="税率%" required>
                                    <el-select v-model="form.taxRate" placeholder="请选择税率" @change="updateRate"
                                               style="width: 200px">
                                        <el-option label="13" value="13"></el-option>
                                        <el-option label="10" value="10"></el-option>
                                        <el-option label="3" value="3"></el-option>
                                        <el-option label="0" value="0"></el-option>
                                    </el-select>
                                </el-form-item>
                                <el-form-item label="签订人" required>
                                    <el-input style="width:200px" v-model="form.signedBy" placeholder="请输入签订人">
                                    </el-input>
                                </el-form-item>
                                <el-form-item label="签订人联系方式">
                                    <el-input style="width:200px" v-model="form.signedTel" placeholder="请输入签订人联系方式">
                                    </el-input>
                                </el-form-item>
                            </div>

                            <div>
                                <el-form-item label="签订日期" required>
                                    <el-date-picker type="date" placeholder="签订日期"
                                                    style="width: 200px"
                                                    value-format="yyyy-MM-dd"
                                                    v-model="form.billDate"></el-date-picker>
                                </el-form-item>
                                <el-form-item label="约定送货日期">
                                    <el-date-picker type="date" placeholder="约定送货日期"
                                                    style="width: 200px" value-format="yyyy-MM-dd"
                                                    v-model="form.deliveryDate"></el-date-picker>
                                </el-form-item>
                                <el-form-item label="收货地址">
                                    <el-input style="width:200px" v-model="form.deliveryAddress" placeholder="请输入收货地址">
                                    </el-input>
                                </el-form-item>
                            </div>

                            <div>
                                <el-form-item label="质量要求">
                                    <el-input style="width:200px" v-model="form.qualityRequire"
                                              placeholder="请输入签订人联系方式">
                                    </el-input>
                                </el-form-item>
                                <el-form-item label="付款条款">
                                    <el-input style="width:200px" v-model="form.paymentClause" placeholder="请输入签订人联系方式">
                                    </el-input>
                                </el-form-item>
                                <el-form-item label="附件">
                                    <div style="padding: 2px 1px; width: 200px;">
                                        <el-button type="primary" size="medium" icon="el-icon-upload"
                                                   @click="uploadFile">上传
                                        </el-button>
                                        <el-button type="primary" size="medium" icon="el-icon-view" @click="showFile">查看
                                        </el-button>
                                    </div>
                                </el-form-item>
                            </div>

                            <div>
                                <el-form-item label="备注">
                                    <el-input style="width:200px" v-model="form.remark" placeholder="请输入备注">
                                    </el-input>
                                </el-form-item>
                            </div>
                        </el-form>
                    </div>
                    <div style="padding: 15px 0 0 0;text-align: right">
                        <el-row>
                            <el-form :inline="true" label-width="120px">
                                <el-form-item label="扫码">
                                    <el-input style="width:200px" v-model="form.scanCode" placeholder="请输入或扫码条形码">
                                    </el-input>
                                </el-form-item>
                                <el-form-item>
                                    <el-button type="warning" icon="el-icon-plus" @click="selMx" size="medium">
                                        选择明细
                                    </el-button>
                                </el-form-item>
                                <el-form-item>
                                    <el-button type="danger" icon="el-icon-delete" @click="delMx" size="medium">
                                        删除明细
                                    </el-button>
                                </el-form-item>
                                <el-form-item>
                                    <el-button type="primary" icon="mdi mdi-content-save" @click="submit" size="medium">
                                        保存账单
                                    </el-button>
                                </el-form-item>
                            </el-form>
                        </el-row>
                    </div>

                    <div class="Xdriver"></div>

                    <div style="padding-top: 10px" v-loading="loading">
                        <ElTableEdit
                                height="430"
                                ref="editTable"
                                :data="dataList"
                                :form="form"
                                :columns="columns"
                                border
                                stripe
                                style="width: 100%"
                                :header-cell-style="headerStyle"
                                :cell-style="cellStyle"
                                :actionsFixed="true"
                                :actionsWidth="70"
                                :conf="conf">
                            <template v-slot:column-actions="{ row, $index }">
                                <el-button @click="delItem(row, $index)"
                                           type="danger" icon="el-icon-delete" size="small">
                                </el-button>
                            </template>
                        </ElTableEdit>
                    </div>

                </el-main>
            </el-container>

            <selDept v-if="showDept"
                     :deptData="deptData"
                     @closeDialog="closeDialog"
                     @checkRow="checkDept">
            </selDept>
            <selCustomer v-if="showCustomer"
                         :customerId="customerId"
                         @closeDialog="closeDialog"
                         @checkRow="checkCustomer">
            </selCustomer>
            <selStaff v-if="showStaff"
                      :staffId="staffId"
                      @closeDialog="closeDialog"
                      @checkRow="checkStaff">
            </selStaff>
            <selWzMore v-if="showProduct"
                       :productInfoId="productInfoId"
                       @closeDialog="closeDialog"
                       @checkRow="checkWz">
            </selWzMore>

            <fileupload v-if="showFileUpload"
                        :fileUrl="fileUrl"
                        :fileParam="fileParam"
                        :fileListUrl="fileListUrl"
                        :delFileUrl="delFileUrl"
                        :fileKey="fileKey"
                        @closeDialog="closeDialog">
            </fileupload>
            <fileDialog v-if="showFileDialog"
                        :fileParam="fileParam"
                        :fileListUrl="fileListUrl"
                        @closeDialog="closeDialog">
            </fileDialog>
            <selProject v-if="showProject"
                        :projectId="projectId"
                        @closeDialog="closeDialog"
                        @checkRow="checkProject">
            </selProject>
        </div>
    </el-dialog>
</template>

<script>
    import fileupload from '@/components/tools/fileupload/dialog'
    import fileDialog from '@/components/tools/fileupload/showDialog'
    import ElTableEdit from '@/components/element/el-table-in-edit'
    import selWzMore from '@/components/page/wzgl/wzgl/selWzMore'

    import selDept from '@/components/rszy/dept/deptSelect/single'
    import selCustomer from '@/components/page/customer/customer/selCustomer'
    import selStaff from '@/components/rszy/staff/selStaff'
    import selProject from '@/components/page/project/selProject'

    import {MessageBox} from "element-ui";

    export default {
        name: "mxInfo",
        props: ['formData'],
        components: {
            ElTableEdit,
            selWzMore,
            selDept,
            selCustomer,
            selStaff,
            fileupload,
            fileDialog,
            selProject
        },
        data() {
            return {
                loading: false,

                form: JSON.parse(JSON.stringify(this.formData)),

                showProduct: false,
                selId: "",
                showDept: false,
                deptData: {},
                staffId: "",
                showCustomer: false,
                showStaff: false,
                showProject: false,
                dialogVisible: true,
                dialoading: this.loading,
                customerId: "",
                productInfoId: false,

                conf: {},
                columns: [
                    {
                        title: "序号",
                        width: "60",
                        key: "_xh",
                        type: "index",
                        fixed: true,
                    },
                    {
                        title: "选择",
                        width: "60",
                        key: "selection",
                        type: "selection",
                        fixed: true,
                    },
                    {
                        title: "物资类别",
                        width: "100",
                        key: "typeName",
                    },
                    {
                        title: "物资编码",
                        width: "100",
                        key: "proCode",
                    },
                    {
                        title: "物资名称",
                        width: "150",
                        key: "proName",
                    },
                    {
                        title: "计量单位",
                        key: "units",
                    },
                    {
                        title: "规格型号",
                        key: "specification",
                    },
                    {
                        title: "数量",
                        key: "num",
                        width: "120",
                        edit: true,
                        type: "number",
                        changeLink: true,
                    },
                    {
                        title: "含税单价",
                        key: "taxPrice",
                        width: "120",
                        edit: true,
                        type: "inputSel",
                        method: "costPrice",
                        changeLink: true,
                    },
                    {
                        title: "含税小计",
                        key: "taxTotal",
                        width: "120"
                    },
                    {
                        title: "成本单价",
                        key: "costPrice",
                        width: "120",
                        type: "inputSel",
                        method: "costPrice",
                        edit: true,
                        changeLink: true,
                    },
                    {
                        title: "成本小计",
                        key: "costTotal"
                    },
                    {
                        title: "利润",
                        key: "profitTotal"
                    },
                    {
                        title: "税率%",
                        key: "taxRate"
                    },
                    {
                        title: "税额",
                        key: "tax",
                    },
                    {
                        title: "未税单价",
                        key: "price",
                    },
                    {
                        title: "未税金额",
                        key: "total"
                    },
                    {
                        title: "产地",
                        key: "origin",
                    },
                    {
                        title: "颜色",
                        key: "color",
                    },
                    {
                        title: "备注",
                        key: "remark",
                        width: "150",
                        edit: true,
                    },
                ],
                dataList: [],
                pageInfo: {
                    page: 1,
                    pagesize: 200,
                    pageSizes: [10, 20, 50, 100],
                    total: 0,
                },

                fileUrl: "/billfile/uploadFiles",
                fileListUrl: "/billfile/getBillFile",
                delFileUrl: "/billfile/delete",
                fileKey: "billFileId",
                fileParam: {
                    billId: this.formData.billId
                },
                showFileUpload: false,
                showFileDialog: false,
            }
        },
        watch: {
            formData: {
                handler(val) {
                    this.form = JSON.parse(JSON.stringify(val))
                    this.fileParam = {
                        billId: this.formData.billId
                    }
                    this.getListData();
                },
                deep: true,
            }
        },
        mounted() {
            this.getListData();
        },
        methods: {
            async getListData() {
                if (this.form.billId) {
                    this.loading = true;
                    let param = {
                        url: "/salecontract/listProduct",
                        param: {
                            billId: this.form.billId,
                            limit: this.pageInfo.pagesize,
                            page: this.pageInfo.page
                        }
                    }
                    const data = await this.$store.dispatch('pubMethod', param)
                    if (data.infoCode == "0") {
                        this.dataList = data.data.data;
                        this.pageInfo.total = data.data.count;
                    }
                    this.dataList.map(item => {
                        item._edit = true
                    })
                    this.loading = false;
                }
            },
            clickDept() {
                this.deptData.id = this.form.departmentId
                this.deptData.name = this.form.departmentName
                this.showDept = true;
            },
            checkDept(row) {
                this.form.departmentId = row.id
                this.form.departmentName = row.name
                this.showDept = false;
            },
            selCustomer() {
                this.customerId = this.form.customerId;
                this.showCustomer = true;
            },
            checkCustomer(row) {
                this.form.customerId = row.customerId;
                this.form.customerName = row.customerName;
                this.form.contactName = row.contactName;
                this.form.contactTel = row.contactTel;
                this.showCustomer = false;
            },
            clickStaff() {
                this.staffId = this.form.staffId;
                this.showStaff = true;
            },
            checkStaff(row) {
                this.form.staffId = row.staffId;
                this.form.salesMan = row.staffName;
                this.showStaff = false;
            },
            selProject() {
                this.projectId = this.form.projectId;
                this.showProject = true;
            },
            checkProject(row) {
                this.form.projectId = row.projectId;
                this.form.projectName = row.projectName;
                this.showProject = false;
            },
            headerStyle() {
                return "text-align:center;height:35px;line-height:35px;padding: 5px 0;background-color:#f2f2f2;border-left:1px solid #e5e6e8;border-top:1px solid #e5e6e8;border-bottom:1px solid #e5e6e8"
            },
            cellStyle() {
                return "text-align:center"
            },
            updateRate() {
                let taxRate = this.form.taxRate;
                for (var i = 0; i < this.dataList.length; i++) {
                    this.dataList[i].taxRate = taxRate;

                    if (this.dataList[i].num != undefined && this.dataList[i].num != null && this.dataList[i].num != "") {
                        if (this.dataList[i].taxPrice != undefined && this.dataList[i].taxPrice != null && this.dataList[i].taxPrice != "") {
                            this.dataList[i].taxTotal = this.$pub.getMultiplyData(this.dataList[i].taxPrice, this.dataList[i].num);
                            this.dataList[i].price = this.$pub.getPrice(this.dataList[i].taxRate, this.dataList[i].taxPrice, this.precisionPrice);
                            this.dataList[i].total = this.$pub.getMultiplyData(this.dataList[i].price, this.dataList[i].num, this.precisionTotal);
                            this.dataList[i].tax = this.$pub.getTax(this.dataList[i].taxRate, this.dataList[i].total, this.precisionTotal);
                        } else if (this.dataList[i].price != undefined && this.dataList[i].price != null && this.dataList[i].price != "") {
                            this.dataList[i].total = this.$pub.getMultiplyData(this.dataList[i].price, this.dataList[i].num);
                            this.dataList[i].taxPrice = this.$pub.getTaxPrice(this.dataList[i].taxRate, this.dataList[i].price, this.precisionPrice);
                            this.dataList[i].taxTotal = this.$pub.getMultiplyData(this.dataList[i].taxPrice, this.dataList[i].num, this.precisionTotal);
                            this.dataList[i].tax = this.$pub.getTax(this.dataList[i].taxRate, this.dataList[i].total, this.precisionTotal);
                        }

                        if (this.dataList[i].costPrice != undefined && this.dataList[i].costPrice != null && this.dataList[i].costPrice != "") {
                            this.dataList[i].costTotal = this.$pub.getMultiplyData(this.dataList[i].num, this.dataList[i].costPrice, this.precisionTotal);

                            //计算利润
                            this.dataList[i].profitTotal = this.$pub.getMinusData(this.dataList[i].total, this.dataList[i].costTotal, this.precisionTotal);

                        }
                    }
                }
                this.dataList = JSON.parse(JSON.stringify(this.dataList))

                for (let i = 0; i < this.dataList.length; i++) {
                    this.data[i] = this.dataList[i]
                }
                this.form.taxTotal = this.$pub.getTaxTotal(this.dataList, this.precisionTotal);
            },
            async submit() {
                if (this.$pub.isEmpty(this.form.customerName)) {
                    this.$message({message: '请选择客户信息', type: 'error'});
                    return false;
                }
                if (this.$pub.isEmpty(this.form.salesMan)) {
                    this.$message({message: '请选择业务员信息', type: 'error'});
                    return false;
                }
                if (this.$pub.isEmpty(this.form.contractName)) {
                    this.$message({message: '请选输入合同名称', type: 'error'});
                    return false;
                }
                if (this.$pub.isEmpty(this.form.contractType )) {
                    this.$message({message: '请选择合同类型', type: 'error'});
                    return false;
                }
                if (this.$pub.isEmpty(this.form.invoiceType)) {
                    this.$message({message: '请选择发票类型', type: 'error'});
                    return false;
                }
                if (this.$pub.isEmpty(this.form.taxType)) {
                    this.$message({message: '请选择计税方式', type: 'error'});
                    return false;
                }
                if (this.$pub.isEmpty(this.form.taxRate)) {
                    this.$message({message: '请选择税率', type: 'error'});
                    return false;
                }
                if (this.$pub.isEmpty(this.form.signedBy)) {
                    this.$message({message: '请选择签订人', type: 'error'});
                    return false;
                }
                if (this.$pub.isEmpty(this.form.deliveryDate)) {
                    this.$message({message: '请选择约定送货日期', type: 'error'});
                    return false;
                }

                if (this.$pub.isEmpty(this.form.billDate)) {
                    this.$message({message: '请选择账单日期', type: 'error'});
                    return false;
                } else {
                     /*let billDate = this.form.billDate;
                    let MonthStart = this.$store.state.loginInfo.MonthStart;
                    let MonthEnd = this.$store.state.loginInfo.MonthEnd;
                    if (billDate < MonthStart || billDate > MonthEnd) {
                        this.$message({message: '账单日期不在记账期间内', type: 'error'});
                        return false;
                    }*/
                }
                if (this.dataList.length <= 0) {
                    this.$message({message: '请选择账单明细信息', type: 'error'});
                    return false;
                }


                let systemOptions = await this.$pub.getSystemOptions();
                let minSalePrice_s = systemOptions.minSalePrice;

                for (var i = 0; i < this.dataList.length; i++) {
                    let proName = this.dataList[i].proName;
                    let num = this.dataList[i].num;
                    let taxPrice = this.dataList[i].taxPrice;
                    let minSalePrice = this.dataList[i].minSalePrice;

                    if (this.$pub.isEmpty(num) || this.$pub.isEmpty(taxPrice) ) {
                        this.$message({message: '(' + proName + ')数量或单价不能为空', type: 'error'});
                        return false;
                    }

                    if (parseFloat(num) <= 0 || parseFloat(taxPrice) <= 0) {
                        this.$message({message: '(' + proName + ')数量或单价不能小于等于0', type: 'error'});
                        return false;
                    }

                    if (minSalePrice_s === 1 && minSalePrice != null && minSalePrice != '') {
                        if (parseFloat(taxPrice) < parseFloat(minSalePrice)) {
                            MessageBox.confirm('(' + proName + ')销售价格(' + taxPrice + ')小于最低销售价(' + minSalePrice + '), 是否继续?', '提示', {
                                confirmButtonText: '确定',
                                cancelButtonText: '取消',
                                type: 'warning'
                            }).then(async () => {

                            }).catch(() => {
                                return false
                            })
                        }
                    }

                    this.dataList[i].orderBy = i + 1;
                }
                this.form.saleContractProductList = this.dataList;

                this.loading = true;
                let param = {
                    ...this.form,
                }
                const data = await this.$sqlOpt.save.save(param, "/salecontract/save");
                if (data.infoCode === '0') {
                    this.$message.success("操作成功");
                    this.$emit('closeDialog', this.dialogVisible);
                }
                this.loading = false;
            },
            delMx() {
                let delData = this.$refs.editTable.getSelection();
                if (delData && delData.length > 0) {
                    MessageBox.confirm('是否确认删除选中的记录, 继续?', '提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning'
                    }).then(async () => {
                        delData.map(item => {
                            let index = this.dataList.findIndex(list => {
                                if (list.billProId) {
                                    return list.billProId == item.billProId
                                } else {
                                    return list.randomId == item.randomId
                                }
                            })
                            this.dataList.splice(index, 1);
                        })
                        this.form.taxTotal = this.$pub.getTaxTotal(this.dataList, this.precisionTotal);
                        this.$refs.editTable.validateRow();
                    }).catch(() => {

                    })
                } else {
                    this.$message.warning("请先选择一条记录");
                }
            },
            delItem(row, index) {
                MessageBox.confirm('是否确认删除该记录, 继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(async () => {
                    this.dataList.splice(index, 1);
                    this.form.taxTotal = this.$pub.getTaxTotal(this.dataList, this.precisionTotal);
                    this.$refs.editTable.validateRow();
                }).catch(() => {

                })
            },
            checkWz(rows) {
                rows.map(item => {
                    item.randomId = Math.random()
                    item._edit = true;

                    item.num = 1;
                    item.taxPrice = 0;
                    item.taxTotal = 0;
                    if (item.costPrice01 != null && item.costPrice01 != undefined && item.costPrice01 != '') {
                        item.costPrice = item.costPrice01;
                        item.costTotal = item.costPrice01;
                    }
                    item.taxRate = this.form.taxRate;
                    if (item.taxRate != undefined && item.taxRate != null && item.taxRate != "") {
                        item.price = this.$pub.getPrice(item.taxRate, item.taxPrice, this.precisionPrice);
                        item.total = this.$pub.getMultiplyData(item.price, item.num, this.precisionTotal);
                        item.tax = this.$pub.getTax(item.taxRate, item.total, this.precisionTotal);
                    }
                    if (item.costPrice != undefined && item.costPrice != null && item.costPrice != "") {
                        item.costTotal = this.$pub.getMultiplyData(item.num, item.costPrice, this.precisionTotal);

                        //计算利润
                        item.profitTotal = this.$pub.getMinusData(item.total, item.costTotal, this.precisionTotal);
                    }
                    item.remark = "";
                })
                this.dataList = this.dataList.concat(rows);

                this.form.taxTotal = this.$pub.getTaxTotal(this.dataList, this.precisionTotal);
                this.showProduct = false;
            },
            selMx() {
                this.showProduct = true;
            },
            closeDialog() {
                this.showFileUpload = false;
                this.showFileDialog = false;
                this.showProduct = false;
                this.showDept = false;
                this.showCustomer = false;
                this.showStaff = false;
                this.showProject = false;
            },
            uploadFile() {
                this.showFileUpload = true;
            },
            showFile() {
                this.showFileDialog = true;
            },
            close() {
                this.$emit('closeDialog', this.dialogVisible)
            },
        }
    }
</script>

